// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KryIPiBZP_ckw_lEj5vQ{padding:20px 20px 16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `KryIPiBZP_ckw_lEj5vQ`
};
export default ___CSS_LOADER_EXPORT___;
